import {
    BarChart3, Archive, Bell, Zap, MessageCircle, MessagesSquare, Building, Megaphone, Briefcase, ShoppingCart,
    Book, Clock, Code, Database, LineChart, Flag, Folder, Settings, Globe, Wrench,
    Headphones, Heart, LifeBuoy, Key, FlaskConical, MapPin, Map, Mic, Music, FileText,
    Pencil, Phone, PieChart, HelpCircle, Star, Tag, Keyboard, Wand2, Hammer, Users,
} from "lucide-react";
import React from "react";

export const ICON_NAMES = [
    "bar-chart-3", "archive", "bell", "zap", "message-circle", "messages-square", "building", "megaphone", "briefcase", "shopping-cart",
    "book", "clock", "code", "database", "line-chart", "flag", "folder", "settings", "globe", "wrench",
    "headphones", "heart", "life-buoy", "key", "flask-conical", "map-pin", "map", "mic", "music", "file-text",
    "pencil", "phone", "pie-chart", "help-circle", "star", "tag", "keyboard", "wand-2", "hammer", "users",
] as const;

export type IconName = typeof ICON_NAMES[number];

const ICON_MAP: Record<string, React.ComponentType<any>> = {
    "bar-chart-3": BarChart3, "archive": Archive, "bell": Bell, "zap": Zap,
    "message-circle": MessageCircle, "messages-square": MessagesSquare,
    "building": Building, "megaphone": Megaphone, "briefcase": Briefcase, "shopping-cart": ShoppingCart,
    "book": Book, "clock": Clock, "code": Code, "database": Database, "line-chart": LineChart,
    "flag": Flag, "folder": Folder, "settings": Settings, "globe": Globe, "wrench": Wrench,
    "headphones": Headphones, "heart": Heart, "life-buoy": LifeBuoy, "key": Key,
    "flask-conical": FlaskConical, "map-pin": MapPin, "map": Map, "mic": Mic, "music": Music,
    "file-text": FileText, "pencil": Pencil, "phone": Phone, "pie-chart": PieChart,
    "help-circle": HelpCircle, "star": Star, "tag": Tag, "keyboard": Keyboard,
    "wand-2": Wand2, "hammer": Hammer, "users": Users,
};

export const DEFAULT_ICON: IconName = "book";

interface Props { name: string | null | undefined; size?: number; color?: string; className?: string; }

export function LucideIcon({ name, size = 16, color, className }: Props) {
    const Comp = (name && ICON_MAP[name]) || ICON_MAP[DEFAULT_ICON];
    return <Comp size={size} color={color} className={className} />;
}
